"use client";

import { lazyComponent } from "@/components/ui/lazy-component";
import { LoadFailureNotice } from "@/components/ui/load-failure-notice";
import { SegmentedControl } from "@/components/ui/segmented-control";
import { Skeleton } from "@/components/ui/skeleton";
import { usePriceSeries, type HistoryPoint } from "./use-price-series";

const PriceChart = lazyComponent(
  () => import("./price-chart").then((module) => module.default),
  {
    ssr: false,
    loading: <Skeleton className="h-72 w-full sm:h-80" />,
    failure: {
      label: "price-history-chart",
      fallback: (
        <LoadFailureNotice
          title="The chart could not load."
          className="h-72 sm:h-80"
        />
      ),
    },
  },
);

export function PriceHistoryPanel({
  heading,
  history,
  currency,
}: {
  heading: string;
  history: HistoryPoint[];
  currency: "USD" | "CAD";
}) {
  const series = usePriceSeries(history);
  return (
    <div>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-xl font-bold text-foreground">{heading}</h2>
        <SegmentedControl
          size="compact"
          aria-label="Time range"
          value={series.range}
          onValueChange={series.setRange}
          options={series.rangeOptions}
        />
      </div>
      <PriceChart points={series.points} currency={currency} />
    </div>
  );
}
